export class TeacherInCharge {
    id: number;
    staffTypeOfDisabilityId: number;
    typeOfDisabilityId: number;
    typeDisabilityName: string;
    fullName: string;
    note: string;
    schoolName : number;
    staffStudentYear : number;
    typeOfDisabilityName : string;
    educationAndTrainingName: string;
    staffId: number;
    TypeOfDisabilityId : number;
    studentId : number;
} 